import { CpatAttemptStatus } from "api/resources/cpat/types"
import { useCpat } from "features/Cpat/useCpat"

import CpatCompletedDashboard from "./CpatCompletedDashboard"
import CpatStartDashboard from "./CpatStartDashboard"

const CPATDashboard = () => {
  const { attempt } = useCpat()

  if (
    attempt?.data?.status === CpatAttemptStatus.COMPLETED ||
    attempt.data?.status === CpatAttemptStatus.DISQUALIFIED
  )
    return <CpatCompletedDashboard />

  return <CpatStartDashboard />
}
export default CPATDashboard
